const trackLead = () => {
  if (window.fathom) {
    window.fathom('trackGoal', 'RSR6VQV9', 0);
  }
};

export default trackLead;
